enum ExceptionCode {
  BadRequest = 'E_BAD_REQUEST',
  InternalServer = 'E_INTERNAL_SERVER_EXCEPTION',
  NotFound = 'E_NOT_FOUND',
  CreativeAssociation = 'E_CREATIVE_ASSOCIATION',
}

export default ExceptionCode;
